import {useAuth} from '../auth/use-auth';
import {useSettings} from '@ui/settings/use-settings';
import {useMemo} from 'react';
import {MenuConfig, MenuItemConfig} from '@common/menus/menu-config';
import {filterMenuItems} from '@common/menus/filter-menu-items';

export function useCustomMenu(menuOrPosition?: string | MenuConfig) {
  const settings = useSettings();
  const {user, hasPermission} = useAuth();

  return useMemo(() => {
    if (!menuOrPosition) {
      return null;
    }

    const menu =
      typeof menuOrPosition === 'string'
        ? settings.menus?.find(s => s.positions?.includes(menuOrPosition))
        : menuOrPosition;

    if (!menu) {
      return null;
    }

    const menuItems = filterMenuItems(menu.items, {
      user,
      hasPermission,
      settings,
    });

    return {
      ...menu,
      items: menuItems,
    };
  }, [hasPermission, settings, menuOrPosition, user]);
}
